import styled, { keyframes } from "styled-components";

const spin = keyframes`
  from {
    transform: translate3d(0,0,0) rotate(0);
  }

  to {
    transform: translate3d(0,0,0) rotate(360deg);
  }
`;

export const SpinAnimation = styled.div`
  animation-name: ${spin};
  animation-fill-mode: both;
  animation-direction: forward;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  display: block;
`;
